import type { ScorecardTargets } from '../../api/types';

export type ScorecardChipKey =
  | 'unclaimed'
  | 'driver'
  | 'pickup'
  | 'pod'
  | 'stopped'
  | 'biddingClosed'
  | 'participantKyc';
export type PaymentChipKey =
  | 'advanceAtRiskOrOverdue'
  | 'balanceAtRiskOrOverdue'
  | 'invoiceOverdue'
  | 'shipperPaymentOverdue'
  | 'approvalsWaiting'
  | 'paymentClaimsWaiting';

export function chipHelp(key: ScorecardChipKey, targets: ScorecardTargets): string {
  switch (key) {
    case 'unclaimed':
      return `No owner after ${targets.claimTargetMinutes} min. Claim it.`;
    case 'driver':
      return `Awarded ${targets.driverTargetMinutes} min ago, no driver. Call the partner.`;
    case 'pickup':
      return 'Pickup is today or overdue and the truck has not loaded. Call driver or partner, or update status.';
    case 'pod':
      return `Delivered ${targets.podCloseTargetHours} h ago, POD not verified. Review POD.`;
    case 'stopped':
      return 'Truck is stopped. Open it and check.';
    case 'biddingClosed':
      return 'Bidding ended with no award. Repost or cancel.';
    case 'participantKyc':
      return 'Shipper or partner KYC not verified after award. Open and verify.';
  }
}

const PAYMENT_HELP: Record<PaymentChipKey, string> = {
  advanceAtRiskOrOverdue:
    'Advance is due soon (25% or less of the time left) or past due. Check the payment and follow up.',
  balanceAtRiskOrOverdue:
    'Balance is due soon (25% or less of the time left) or past due. Check the payment and follow up.',
  invoiceOverdue: 'Invoice is past its due date. Check it and send a reminder.',
  shipperPaymentOverdue: 'Shipper has not paid by the due date. Follow up with the shipper.',
  approvalsWaiting: 'A payment is waiting for your approval. Open it and approve or reject.',
  paymentClaimsWaiting: 'A payment claim is waiting for review. Open it and confirm or reject.',
};

export const docsToReviewHelp =
  'Documents uploaded and waiting for ops review. Open the queue to verify or reject them.';

export function paymentChipHelp(key: PaymentChipKey): string {
  return PAYMENT_HELP[key];
}
